import dotProp from 'dot-prop-immutable';

import {
    REDUCE_CERTIFICATE_APPLIED,
    REDUCE_CHECKOUT_OPTION,
    REDUCE_CONFIRM_RESULT,
    REDUCE_ENTITY,
    REDUCE_INSURED_ELEMENT,
    REDUCE_IS_SINGLE_PAYMENT,
    REDUCE_PARAMETER,
    REDUCE_PARAMETERS,
    REDUCE_PAYMENT_ELEMENT,
    REDUCE_POLICY,
    REDUCE_POLICY_ELEMENT,
    REDUCE_POLICY_QUOTE_ROUTING,
    REDUCE_POLICY_SUMMARY,
    REDUCE_QUOTES,
    REDUCE_QUOTING,
    REDUCE_SUBMISSION_ELEMENT,
    REDUCE_SUMMARY,
} from '../../constants/actions/policy';

const initialState = {
    entity: null,
    parameters: [],
    policy: null,
    policyQuoteRouting: null,
    policySummary: null,
    isSinglePayment: false,
    quotes: null,
    summary: null,
    confirmResult: null,
    checkoutOption: null,
    certificateApplied: false,
};

function policyReducer(state = initialState, action) {
    switch (action.type) {
        case REDUCE_ENTITY:
            return dotProp.set(state, 'entity', action.payload);
        case REDUCE_POLICY_ELEMENT: {
            if (state.policy) {
                return dotProp.set(state, `policy.${action.payload.code}`, action.payload.value);
            }
            const policy = dotProp.set({}, `${action.payload.code}`, action.payload.value);
            return dotProp.set(state, 'policy', policy);
        }
        case REDUCE_SUBMISSION_ELEMENT: {
            if (state.policy) {
                return dotProp.set(state, `policy.submission.${action.payload.code}`, action.payload.value);
            }
            const submissionPolicy = dotProp.set({}, `${action.payload.code}`, action.payload.value);
            return dotProp.set(state, 'policy', submissionPolicy);
        }
        case REDUCE_PAYMENT_ELEMENT: {
            if (state.policy) {
                return dotProp.set(state, `policy.payment.${action.payload.code}`, action.payload.value);
            }
            const paymentPolicy = dotProp.set({}, `${action.payload.code}`, action.payload.value);
            return dotProp.set(state, 'policy', paymentPolicy);
        }
        case REDUCE_INSURED_ELEMENT: {
            if (state.policy) {
                return dotProp.set(state, `policy.participants.insured.${action.payload.code}`, action.payload.value);
            }
            const insuredPolicy = dotProp.set({}, `${action.payload.code}`, action.payload.value);
            return dotProp.set(state, 'policy', insuredPolicy);
        }
        case REDUCE_POLICY_SUMMARY:
            return dotProp.set(state, 'policySummary', action.payload);
        case REDUCE_POLICY:
            return dotProp.set(state, 'policy', action.payload);
        case REDUCE_PARAMETERS:
            return dotProp.set(state, 'parameters', action.payload);
        case REDUCE_PARAMETER: {
            if (!action.payload) return state;

            let parameterIndex = 0;
            if (state.parameters.some((x) => x.code === action.payload.code)) {
                parameterIndex = state.parameters.findIndex((x) => x.code === action.payload.code);
            } else {
                parameterIndex = state.parameters.length;
            }
            return dotProp.set(state, `parameters.${parameterIndex}`, {
                code: action.payload.code,
                value: action.payload.value,
            });
        }
        case REDUCE_QUOTING:
            return dotProp.set(state, 'quoting', action.payload);
        case REDUCE_IS_SINGLE_PAYMENT:
            return dotProp.set(state, 'isSinglePayment', action.payload);
        case REDUCE_POLICY_QUOTE_ROUTING:
            return dotProp.set(state, 'policyQuoteRouting', action.payload);
        case REDUCE_QUOTES:
            return dotProp.set(state, 'quotes', action.payload);
        case REDUCE_SUMMARY:
            return dotProp.set(state, 'summary', action.payload);
        case REDUCE_CONFIRM_RESULT:
            return dotProp.set(state, 'confirmResult', action.payload);
        case REDUCE_CHECKOUT_OPTION:
            return dotProp.set(state, 'checkoutOption', action.payload);
        case REDUCE_CERTIFICATE_APPLIED:
            return dotProp.set(state, 'certificateApplied', action.payload);
        default:
            return state;
    }
}

export default policyReducer;
